import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './containers/App';
import NotFoundPage from './containers/NotFoundPage.js';
import LoginPage from './containers/LoginPage';
import AccountList from './containers/AccountList';
import AccountCreate from './containers/AccountCreate';
import AccountModify from './containers/AccountModify';
import PacketboxList from './containers/PacketboxList';
import PacketboxModify from './containers/PacketboxModify';
import EndUserKeyList from './containers/EndUserKeyList';
import EndUserKeyCreate from './containers/EndUserKeyCreate';
import EndUserList from './containers/EndUserList';
import EndUserCreate from './containers/EndUserCreate';
import EndUserModify from './containers/EndUserModify';
import EventList from './containers/EventList';
import LoraConfigList from './containers/LoraConfigList';
import LoraConfigCreate from './containers/LoraConfigCreate';
import LoraConfigModify from './containers/LoraConfigModify';
import Messages from './containers/Messages';
import AlertList from './containers/AlertList';
import AlertTypeList from './containers/AlertTypeList';
import AlertTypeModify from './containers/AlertTypeModify';

export default (
  <Route>
    <Route path="login" component={LoginPage} />
    <Route path="/" component={App}>
      <IndexRoute component={PacketboxList} />
      <Route path="accounts" component={AccountList} />
      <Route path="accounts/new" component={AccountCreate} />
      <Route path="accounts/modify/*" component={AccountModify} />
      <Route path="packetboxes" component={PacketboxList} />
      <Route path="packetboxes/modify/*" component={PacketboxModify} />
      <Route path="end-users" component={EndUserList} />
      <Route path="end-users/new" component={EndUserCreate} />
      <Route path="end-users/modify/*" component={EndUserModify} />
      <Route path="authorizations" component={EndUserKeyList} />
      <Route path="authorizations/new" component={EndUserKeyCreate} />
      <Route path="events" component={EventList} />
      <Route path="messages" component={Messages} />
      <Route path="lora-configs" component={LoraConfigList} />
      <Route path="lora-configs/new" component={LoraConfigCreate} />
      <Route path="lora-configs/modify/*" component={LoraConfigModify} />
      <Route path="alerts" component={AlertList} />
      <Route path="alert-types" component={AlertTypeList} />
      <Route path="alert-types/modify/*" component={AlertTypeModify} />
      <Route path="*" component={NotFoundPage} />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js